import Route from '@ember/routing/route';

import $ from 'jquery';

export default class DatawallRoute extends Route {
	override beforeModel(): void {
		$('body').attr('id', 'datawall');

		// adding a polyfill since some TVs don't support Promise.allSettled (e.g. Chrome <76)
		// this is just a temp solution. See https://app.asana.com/0/1200164142655153/1205988912705965/f
		Promise.allSettled =
			Promise.allSettled ||
			((promises: Promise<unknown>[]) =>
				Promise.all(
					promises.map((p) =>
						p
							.then((value) => ({
								status: 'fulfilled',
								value,
							}))
							.catch((reason: unknown) => ({
								status: 'rejected',
								reason,
							})),
					),
				));
	}
}
